import { render } from "./BidForm.vue?vue&type=template&id=18f50040"
import script from "./BidForm.vue?vue&type=script&lang=js"
export * from "./BidForm.vue?vue&type=script&lang=js"

import "./BidForm.vue?vue&type=style&index=0&id=18f50040&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__